import { render, staticRenderFns } from "./add-ad-keyword.vue?vue&type=template&id=06822adc&scoped=true&"
import script from "./add-ad-keyword.vue?vue&type=script&lang=js&"
export * from "./add-ad-keyword.vue?vue&type=script&lang=js&"
import style0 from "./add-ad-keyword.vue?vue&type=style&index=0&id=06822adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06822adc",
  null
  
)

export default component.exports